import { IconButton } from '@mui/material';
import styled from 'styled-components';

const WizardContainer = styled.div`
  height: calc(100% - 30px);
  position: relative;
`;
const WizardFooter = styled.div`
  height: 30px;
  background-color: rgb(32, 144, 136);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  color: white !important;
`;

const WizardContent = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0 px;
`;

const Back = styled(IconButton)`
  position: absolute !important;
  top: 20px;
  left: 0px;
  color: rgb(32, 144, 136);
  opacity: 0.7;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  z-index: 1001;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 60px;
  }
`;

const Img = styled.img`
  width: 8px;
  height: 15px;
  margin-right: 10px;
`;

const Link = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid #2563eb;
  border-radius: 8px;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 40px;
  margin-top: 80px;
  background-color: #2563eb;
  color: #fff;
  transition: all 0.2s ease;

  svg {
    fill: #fff;
    color: #fff;
  }

  &:hover {
    background-color: #1d4ed8;
    border-color: #1d4ed8;
    cursor: pointer;
  }
  
  @media (max-width: 480px) {
    display: none;
  }
`;

const LinkHowToUse = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  border: none;
  margin-top: 80px;
  margin-right: 40px;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 90px;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;


export { WizardContainer, WizardFooter, WizardContent, Back, Img, Link, LinkHowToUse };
